module.exports = __webpack_public_path__ + "img/bg3.824d7d36.png";